// Add your custom JS here.

jQuery(document).ready(function ($) {
    let myCollapsible = document.getElementById('navbarNavDropdownMob')
    myCollapsible.addEventListener('hidden.bs.collapse', function () {
        $('.open_menu').hide();
    });
    myCollapsible.addEventListener('shown.bs.collapse', function () {
        $('.open_menu').show();
    });
    myCollapsible.addEventListener('hide.bs.collapse', function () {
        console.log('hide');
    });


    // let currentPage = 1;
    // let category = 'all';
    // let isLoading = false;
    // let container = $('.ajax-container');
    // let loadMoreButton = $('#load-more');
    // let categoryFilter = $('#category-filter');
    // let loadedPosts = {}; // Keep track of loaded post IDs
    //
    // function loadPosts() {
    //     if (isLoading) return;
    //     isLoading = true;
    //
    //     $.ajax({
    //         url: ajax_archive_params.ajax_url,
    //         type: 'POST',
    //         data: {
    //             action: 'custom_ajax_archive',
    //             security: ajax_archive_params.category_nonce,
    //             page: currentPage,
    //             category: category,
    //         },
    //         beforeSend: function () {
    //             loadMoreButton.text('Loading...');
    //         },
    //
    //         success: function (response) {
    //             if (response.success) {
    //                 if (response.data.html !== '') {
    //                     container.append(response.data.html);
    //                     currentPage++;
    //
    //                     if (currentPage > response.data.max_pages) {
    //                         loadMoreButton.hide();
    //                     }
    //                 } else {
    //                     loadMoreButton.hide();
    //                 }
    //             } else {
    //                 console.log('Error:', response.data.message);
    //             }
    //
    //             isLoading = false;
    //             loadMoreButton.text('Load More');
    //         },
    //         error: function (xhr, status, error) {
    //             console.log('Error:', error);
    //             isLoading = false;
    //             loadMoreButton.text('Load More');
    //         },
    //     });
    // }
    //
    // function resetArchive() {
    //     container.empty();
    //     currentPage = 1;
    //     loadedPosts = {}; // Reset loaded posts
    //     loadMoreButton.show();
    // }
    //
    // categoryFilter.on('click', '.category', function () {
    //     category = $(this).data('category');
    //     resetArchive();
    //     loadPosts();
    // });
    //
    // loadMoreButton.on('click', function () {
    //     loadPosts();
    // });

})
jQuery(document).ready(function ($) {
    let currentPage = 1;
    let currentCategory = 'all'; // Track the currently selected category
    let loading = false;
    let noMorePosts = false;
    let count = $(".ajax-container").children().length;
    let data_posts_per_page = $('.blog-list').attr('data-posts-per-page');
    if (count < data_posts_per_page) {
        $('#load-more').addClass('d-none');

    }

    function loadMorePosts(category) {
        if (loading || noMorePosts) return;
        loading = true;
        let posts_per_page = $('.blog-list').attr('data-posts-per-page');
        $('#load-more').removeClass('d-none').text('Loading...');

        let data = {
            'action': 'load_more_posts',
            'page': currentPage + 1,
            'category': category,
            'posts_per_page': posts_per_page
        };
        let ajaxurl = ajax_archive_params.ajax_url;

        $.post(ajaxurl, data, function (response) {
            if (response.success) {
                if (response.data.html) {
                    $('.ajax-container').append(response.data.html);
                    currentPage++;
                }
                if (response.data.noMorePosts) {
                    $('#load-more').addClass('d-none');
                    noMorePosts = true;
                } else {
                    $('#load-more').removeClass('d-none');
                }
            }

            loading = false;
            $('#load-more').text('Load More');
        });
    }

    // Category filtering
    $('#category-filter .category').on('click', function () {
        $('#load-more').removeClass('d-none');
        var category = $(this).data('category');
        if (category !== currentCategory) {
            currentCategory = category;
            currentPage = 0; // Reset currentPage when a new category is selected
            $('.ajax-container').empty(); // Clear existing posts
            $('.category').removeClass('active');
            $(this).addClass('active');
            noMorePosts = false;
            loadMorePosts(category);
        }
    });

    // Load more button
    $('#load-more').on('click', function () {
        let curr_data_cat = $(this).attr('data-category');
        if (curr_data_cat) {
            currentCategory = curr_data_cat;
        }
        loadMorePosts(currentCategory); // Use the current category for loading more posts
    });

//     function initializeAOS(options) {
//         AOS.init(options);
//     }
//
// // Check window width and reinitialize AOS with new options if necessary
//     function checkAndReinitializeAOS() {
//         var options;
//
//         if (window.innerWidth < 992) {
//             // Options for small screens
//             options = {
//                 once: true,
//                 duration: 600, // Adjust duration as needed
//                 offset: 400, // Adjust offset as needed
//             };
//         } else {
//             // Options for larger screens
//             options = {
//                 once: true,
//                 offset: -550, // Adjust offset as needed
//                 duration: 800 // Adjust duration as needed
//             };
//         }
//
//         initializeAOS(options);
//     }
//
// // Initialize AOS on page load
//     checkAndReinitializeAOS();
//
// // Reinitialize AOS when window is resized
//     window.addEventListener('resize', checkAndReinitializeAOS);
//
//     function removeAOSOffsetOnMobile() {
//         var divs = document.querySelectorAll('div'); // Select all div elements
//         divs.forEach(function(div) {
//             if (window.innerWidth < 992) {
//                 div.removeAttribute('data-aos-offset');
//             }
//         });
//     }
//
//     removeAOSOffsetOnMobile();
//     window.addEventListener('resize', removeAOSOffsetOnMobile);

});
